import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Bath() {
  return <CityManagementPage config={allCityConfigs.bath} />;
}